// Module
var code = "<relations-sub-table relations=\"$ctrl.relationList\"></relations-sub-table> ";
// Exports
export default code;